import { EEmailEventType } from "../emailNotifications.types";

export * from "./enums";

export const EVENT_TYPE_LABELS: Record<EEmailEventType, string> = {
  [EEmailEventType.SuspiciousBehavior]: "Suspicious behavior",
  [EEmailEventType.DigestSummary]: "Digest summary",
  [EEmailEventType.SupportTicketCreated]: "New support ticket"
};

export const EVENT_TYPE_DESCRIPTIONS: Record<EEmailEventType, string> = {
  [EEmailEventType.SuspiciousBehavior]:
    "Immediate alerts on critical admin actions",
  [EEmailEventType.DigestSummary]:
    "Daily 18:00 (Africa/Abidjan) rollup of all changes",
  [EEmailEventType.SupportTicketCreated]:
    "One email per ticket created, from any channel"
};

export const EVENT_TYPE_COLORS: Record<EEmailEventType, string> = {
  [EEmailEventType.SuspiciousBehavior]: "#FB3973",
  [EEmailEventType.DigestSummary]: "#FF9900",
  [EEmailEventType.SupportTicketCreated]: "#2E90FA"
};

export const EVENT_TYPE_VALUES: EEmailEventType[] = [
  EEmailEventType.SuspiciousBehavior,
  EEmailEventType.DigestSummary,
  EEmailEventType.SupportTicketCreated
];
